import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
   client: {
      VITE_CLERK_PUBLISHABLE_KEY: z.string(),
      VITE_API_BASE_URL: z.url(),
      VITE_CLOUDINARY_CLOUD_NAME: z.string(),
      VITE_CLOUDINARY_BASE_FOLDER: z.string(),
   },
   clientPrefix: "VITE",
   runtimeEnv: {
      VITE_CLERK_PUBLISHABLE_KEY: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
      VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
      VITE_CLOUDINARY_CLOUD_NAME: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME,
      VITE_CLOUDINARY_BASE_FOLDER: import.meta.env.VITE_CLOUDINARY_BASE_FOLDER,
   },
});
